var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_mixins["container"] = pug_interp = function(className){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["container",className], [false,true])},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_html = pug_html + "\u003Cdiv class=\"popup-video\" @click.self=\"closePopup\"\u003E";
pug_mixins["container"].call({
block: function(){
pug_html = pug_html + "\u003Cbutton class=\"popup-video__close\" @click=\"closePopup\"\u003E\u003Csvg width=\"28\" height=\"28\" viewBox=\"0 0 28 28\" fill=\"none\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\"\u003E\n\u003Cpath d=\"M2 2L26 26\" stroke-width=\"3\"\u002F\u003E\n\u003Cpath d=\"M26 2L2 26\" stroke-width=\"3\"\u002F\u003E\n\u003C\u002Fsvg\u003E\n\u003C\u002Fbutton\u003E\u003Cdiv class=\"popup-video__content\"\u003E\u003Ciframe class=\"baseSlider__video\" :src=\"videoSrc\" frameborder=\"0\" width=\"100%\" height=\"100%\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\"\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E";
}
}, 'popup-video__container');
pug_html = pug_html + "\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./new-blocks/popup/video/popup-video.pug
// module id = ./new-blocks/popup/video/popup-video.pug
// module chunks = 0 2